import { render, staticRenderFns } from "./BusinessLayer.vue?vue&type=template&id=50644dcc"
import script from "./BusinessLayer.vue?vue&type=script&lang=js"
export * from "./BusinessLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports